export const StarInput = ({
  index,
  value,
  onValueChange,
}: {
  index: number;
  value: number;
  onValueChange: (value: number) => void;
}) => {
  const uniqueKey = `${index}`;
  const id = `star-${uniqueKey}`;

  return (
    <label
      data-testid="star-input-label"
      htmlFor={id}
      title={`${index}/5`}
      role="presentation"
    >
      <input
        data-testid="star-input"
        id={id}
        checked={value === index}
        defaultValue={index}
        name={`rating-${index}`}
        type="radio"
        onChange={(e) => {
          onValueChange(+e.target.value);
        }}
      />
    </label>
  );
};
